import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
body {
  background: ${({ theme }) => theme.colors.white};
}

.grecaptcha-badge {
  visibility: hidden;
}
`;
